<template>
    <div class="trade-refferences">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <!-- <h3 class="mb-0">Trade References</h3> -->
                  <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           Trade References
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_trade_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            <div v-if="tableData.length > 0" class="rounded-bottom">
                <el-table
                :data="tableData"
                show-summary
                :summary-method="getSummaries"
                fit
                style="width: 100%">
                    <el-table-column
                        label="Aging Date / Default Days"
                        min-width="170"
                        width="auto">
                        <template slot="header" slot-scope="scope">
                            <span class="text-break">{{ scope.column.label }}</span>
                        </template>
                        <template slot-scope="scope">
                            <p class="mb-0 top-line">{{ scope.row.trade_ref_aging_date }}</p>
                            <p class="text-uppercase bottom-line mb-0">{{ scope.row.missed_pay_loan_statue }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Referee/Tel"
                        min-width="260"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="mb-0 text-break top-line">{{ scope.row.trade_ref_referee_name }}</p>
                            <p class="text-uppercase bottom-line mb-0">{{ scope.row.trade_ref_referee_tel }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="trade_ref_outstanding_amt"
                        label="Outstanding (RM)"
                        width="200">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.trade_ref_outstanding_amt | moneyFormatter }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No Trade References recorded</p>
            </div>
        </b-card>
        <TradeRefferencesModal
          :trade-refferences="tradeRefferences" 
          :trade-reference-resp="tradeReferenceResp"
          :show_trade_full_view.sync="modals.show_trade_full_view"
        />
    </div>
</template>
<script>
    import { Table, TableColumn } from 'element-ui'
    import TradeRefferencesModal from '@/views/CustomerProfile/CustomerModals/TradeRefferencesModal.vue'

    export default {
        name: 'trade-refferences',
        props: ['trade-refferences',
           'tradeReferenceResp' ],
        components: {
            TradeRefferencesModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.tradeRefferences,
                modals: {
                  show_trade_full_view: false
                }
            }
        },
        methods: {
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = 'Total';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                        }, 0).toLocaleString(undefined, {minimumFractionDigits: 2});
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            }
        }
    }
</script>